module.exports = __webpack_public_path__ + "img/officefriend.8f654b51.svg";